import React, { useRef } from 'react';
import { Box, Card, CardContent, CardHeader, Container, Grid, Typography, Button, useTheme } from "@mui/material"
import * as am5 from "@amcharts/amcharts5"
import * as am5xy from "@amcharts/amcharts5/xy"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import { useLayoutEffect } from "react"

const flujosTerminadosData = [
    { tipo: "Activos", completado: 100, color: "primary" },
    { tipo: "Finalizados", completado: 2, color: "grey"  },
]

const FlujosTerminados = (ConversationData) => {
    const theme = useTheme()
    const chartRef = useRef(null);

    useLayoutEffect(() => {
        if (!chartRef.current) return

        // Crear instancia del gráfico
        const root = am5.Root.new(chartRef.current)
        root.setThemes([am5themes_Animated.new(root)])

        // Crear gráfico de barras
        const chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panX: false,
                panY: false,
                wheelX: "none",
                wheelY: "none",
                layout: root.verticalLayout,
            }),
        )

        // Crear ejes
        const yAxis = chart.yAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "tipo",
                renderer: am5xy.AxisRendererY.new(root, {})
            })
        )
        yAxis.get("renderer").labels.template.set("visible", false); // Ocultar nombres del eje Y
        yAxis.data.setAll(ConversationData.ConversationData)

        const xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(root, {
                min: 0,
                max: 100,
                renderer: am5xy.AxisRendererX.new(root, {}),
            }),
        )

        // Crear series
        const series = chart.series.push(
            am5xy.ColumnSeries.new(root, {
            name: "Series",
            xAxis: xAxis,
            yAxis: yAxis,
            valueXField: "completado",
            categoryYField: "tipo",
            }),
        )

        series.columns.template.adapters.add("fill", (fill, target) => {
            if (target.dataItem.dataContext.color === "gray") {
                return am5.color("#808080"); // Gris
            }
            return am5.color(theme.palette.primary.main);
        });

        series.columns.template.adapters.add("stroke", (stroke, target) => {
            if (target.dataItem.dataContext.color === "gray") {
                return am5.color("#808080"); // Gris
            }
            return am5.color(theme.palette.primary.dark);
        });

        series.columns.template.setAll({
            fillOpacity: 0.8,
            strokeWidth: 2,
            cornerRadiusTR: 5,
            cornerRadiusBR: 5,
            cornerRadiusTL: 0,
            cornerRadiusBL: 0,
        })

        series.data.setAll(ConversationData.ConversationData)
        series.appear(1000)

        // Agregar leyenda
        const legend = chart.children.push(am5.Legend.new(root, {}));
        legend.markers.template.setAll({
            width: 12,
            height: 12,
        });

        legend.labels.template.setAll({
            fontSize: 12,
            fill: am5.color(0x000000),
        });

        legend.data.setAll(series.dataItems.map(dataItem => ({
            name: dataItem.get("categoryY"),
            fill: dataItem.get("fill")
        })));

        // Set the legend for the series
        series.set("legend", legend);

        return () => {
            root.dispose()
        }
    }, [ConversationData])

    return (
        <Card style={{ height: "100%" }}>
            <CardHeader title="Flujos Terminados" />
            <CardContent>
                <Box ref={chartRef} style={{ width: "100%", height: 200 }} />
                <Box display="flex" justifyContent="center" p={2} sx={{ gap: 2, border: 1, borderColor: 'divider' }}>
                    {ConversationData.ConversationData.map((item, index) => (
                        <Box key={index} display="flex" alignItems="center" sx={{ gap: 1 }}>
                            <Box sx={{ width: 12, height: 12, backgroundColor: item.color === "gray" ? "#808080" : theme.palette.primary.main }} />
                            <Typography variant="caption" color="textSecondary">
                                {item.tipo}: {Number(item.completado).toFixed(2)}%
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    )
}

export default FlujosTerminados;